// 📁 src/lightversion/config/liteLearningContent.js

const liteLearningContent = {
  1: {
    concept: "Passion with Purpose",
    explanation:
      "The strongest founders combine both: they feel passionate about solving something, but their purpose is tied to a deeper, unresolved tension that won’t let them quit",
    framework: {
      title: "Problem–Person–Pain",
      points: [
        "Who is experiencing the problem?",
        "What situation triggers it?",
        "Why does it matter right now?",
      ],
    },
    applyPrompt:
      "If this problem remains unsolved, who feels the pain most — and how?",
  },

  2: {
    concept: "A real problem is observable",
    explanation:
      "If you cannot point to behavior, friction, or workaround, the problem may only exist in theory.",
    framework: {
      title: "Problem Statement Formula",
      points: [
        "When [user] tries to [task]",
        "They struggle because [constraint]",
        "This results in [negative outcome]",
      ],
    },
    applyPrompt:
      "What real-world behavior proves this problem exists?",
  },

  3: {
    concept: "Ideas are hypotheses, not answers",
    explanation:
      "Early ideas feel exciting because they reduce uncertainty — not because they are correct.",
    framework: {
      title: "Assumption Scan",
      points: [
        "What must be true for this idea to work?",
        "Which assumption is riskiest?",
        "How would you know if it’s wrong?",
      ],
    },
    applyPrompt:
      "Which assumption, if false, would break this idea?",
  },

  4: {
    concept: "Interest is not validation",
    explanation:
      "Positive reactions and compliments feel encouraging, but they are weak signals. Validation only begins when users change behavior, invest time, or make a sacrifice.",
    framework: {
      title: "Signal Ladder",
      points: [
        "Verbal interest (opinions, likes, compliments)",
        "Time or attention invested",
        "Behavior change or workaround adoption",
        "Money, commitment, or risk taken",
      ],
    },
    applyPrompt:
      "What would a real user have to do for you to believe this problem is genuinely real?",
  },

  5: {
    concept: "MVP tests risk, not completeness",
    explanation:
      "The goal of an MVP is to learn fast — not to look finished.",
    framework: {
      title: "Riskiest Assumption First",
      points: [
        "What must be true for this to work?",
        "What is hardest to prove?",
        "What can be tested fastest?",
      ],
    },
    applyPrompt:
      "What is the one thing that must be true for this idea to survive?",
  },
};

export default liteLearningContent;
